var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from 'styled-components';
import { Eyebrow, Icon, Header, CTAs, Body } from '../../ContentSystem.shared.styles';
import { applyTextWrap } from '../../utils/utils';
export var TextSet = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n\n  & > ", ":last-child {\n    margin-bottom: 0;\n    margin-right: 0;\n    ", "\n  }\n  ", " {\n    max-width: 640px;\n  }\n\n  ", " {\n    ", "\n    ", "\n\n    & h1,\n    & h2,\n    & h3,\n    & h4,\n    & h5,\n    & h6 {\n      ", "\n      ", "\n    }\n\n    & p {\n      max-width: 640px;\n      ", "\n    }\n  }\n\n  ", " {\n    ", "\n\n    ", "\n\n    & > * {\n      ", ";\n    }\n\n    ", ";\n\n    & h1,\n    & h2,\n    & h3,\n    & h4,\n    & h5,\n    & h6 {\n      max-width: ", ";\n      ", "\n    }\n\n    & > *:empty:not(img):not(br) {\n      display: none;\n    }\n  }\n\n  & > :nth-last-child(2) {\n    ", "\n  }\n"], ["\n  ", "\n\n  & > ", ":last-child {\n    margin-bottom: 0;\n    margin-right: 0;\n    ", "\n  }\n  ", " {\n    max-width: 640px;\n  }\n\n  ", " {\n    ", "\n    ", "\n\n    & h1,\n    & h2,\n    & h3,\n    & h4,\n    & h5,\n    & h6 {\n      ", "\n      ", "\n    }\n\n    & p {\n      max-width: 640px;\n      ", "\n    }\n  }\n\n  ", " {\n    ", "\n\n    ", "\n\n    & > * {\n      ", ";\n    }\n\n    ", ";\n\n    & h1,\n    & h2,\n    & h3,\n    & h4,\n    & h5,\n    & h6 {\n      max-width: ", ";\n      ", "\n    }\n\n    & > *:empty:not(img):not(br) {\n      display: none;\n    }\n  }\n\n  & > :nth-last-child(2) {\n    ", "\n  }\n"])), function (_a) {
    var textAlignment = _a.textAlignment;
    return textAlignment === 'TEXT_CENTER' &&
        "\n      align-items: center;\n      text-align: center;\n      ".concat(Icon, " {\n        text-align: center;\n        margin: auto;\n      }\n    ");
}, CTAs, function (_a) {
    var headerMaxLineLength = _a.headerMaxLineLength, buttonOverflow = _a.buttonOverflow;
    return buttonOverflow === 'WRAP'
        ? "\n        max-width: ".concat(headerMaxLineLength ? "".concat(headerMaxLineLength, "ch") : '640px', ";")
        : '';
}, Eyebrow, Body, applyTextWrap(), function (_a) {
    var elementType = _a.elementType;
    return "\n      max-width: ".concat(elementType === 'card' ? '640px' : 'none', ";\n    ");
}, function (_a) {
    var headerMaxLineLength = _a.headerMaxLineLength;
    return headerMaxLineLength
        ? "\n              max-width: ".concat(headerMaxLineLength, "ch;\n            ")
        : 'max-width: 640px;';
}, applyTextWrap(), applyTextWrap(), Header, applyTextWrap(), function (_a) {
    var maxWidthWrapper = _a.maxWidthWrapper;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      ", "\n    "], ["\n      ", "\n    "])), maxWidthWrapper ? 'max-width: 640px;' : '');
}, function (_a) {
    var headerMaxLineLength = _a.headerMaxLineLength;
    return headerMaxLineLength
        ? "max-width: ".concat(headerMaxLineLength, "ch")
        : 'max-width: 640px';
}, function (_a) {
    var headerMaxLineLength = _a.headerMaxLineLength;
    return headerMaxLineLength
        ? "max-width: ".concat(headerMaxLineLength, "ch")
        : 'max-width: 640px';
}, function (_a) {
    var headerMaxLineLength = _a.headerMaxLineLength;
    return headerMaxLineLength ? "".concat(headerMaxLineLength, "ch") : '640px';
}, applyTextWrap(), function (props) {
    return props.hasCTAs &&
        "\n      margin-bottom: 0;\n    ";
});
export default {};
var templateObject_1, templateObject_2;
